import { render, staticRenderFns } from "./NeoparentDashboardProfile.vue?vue&type=template&id=68f4a588&scoped=true"
import script from "./NeoparentDashboardProfile.vue?vue&type=script&lang=js"
export * from "./NeoparentDashboardProfile.vue?vue&type=script&lang=js"
import style0 from "./NeoparentDashboardProfile.vue?vue&type=style&index=0&id=68f4a588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4a588",
  null
  
)

export default component.exports